import React, { Component } from 'react'
import PageWrapper from './PageWrapper'
import FourOFourBody from './FourOFourBody'

/**
 * A basic component that utilizes the standard page wrapper and 404 body
 * to display a 404 page. Primarily for react-router to default to an unknown
 * location
 */
export default class Generic404 extends Component {
  /**
   * Render component
   */
  render () {
    return (
      <PageWrapper>
        <FourOFourBody />
      </PageWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Generic404.js